module.exports = __webpack_public_path__ + "assets/go-back.657274ce.svg";